// NAP — butun sayt bo'ylab yagona manba
export const CONTACT = {
    phoneDisplay: "+998 90 954 12 62",
    phoneHref: "tel:+998909541262",
    telegram: "https://t.me/azimjon_bekmurodov",
    telegramLabel: "@azimjon_bekmurodov",
    mapsUrl: "https://maps.google.com/?q=U-ENTER+Innovation+Center+Shakhrisabz+Tashkent",
    mapEmbed:
        "https://www.google.com/maps?q=U-ENTER%20innovation%20center%2C%20Shahrisabz%20ko'chasi%2C%20Toshkent&output=embed",
};

// Telegram — ariza formasi shu guruhga tushadi
export const TELEGRAM = {
    token: process.env.REACT_APP_TELEGRAM_BOT_TOKEN || "7909825015:AAFsATQjEhjEHbbxZsqOzl8D7hFavKLsNCw",
    chatId: process.env.REACT_APP_TELEGRAM_CHAT_ID || "-5599408893",
};
